import ReportProblemRoundedIcon from '@mui/icons-material/ReportProblemRounded'
import { Box, Stack, ToggleButton, ToggleButtonGroup, Typography } from '@mui/material'
import { ReactNode } from 'react'
import { INodeExecEnvItem } from '../../../definitions/NodesExecution'

interface P {
    title: string
    mode: string
    setMode: (mode: string) => void
    data: INodeExecEnvItem[]
    renderContent: (item: INodeExecEnvItem, i: number) => ReactNode
    noDataText?: string
    error?: boolean
    errorMessage?: string
}

const PanelSection = ({ title, mode, setMode, data, renderContent, noDataText = 'No data', error, errorMessage }: P) => (
    <Stack style={{ height: '100%', overflow: 'hidden' }} spacing={2}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline' }}>
            <Typography marginBottom={2} variant='h6'>{title}</Typography>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <ToggleButtonGroup
                    onChange={(_, value) => value && setMode(value)}
                    exclusive
                    size='small'
                    color='primary'
                    value={mode}>
                    <ToggleButton value='json'>json</ToggleButton>
                    <ToggleButton value='table'>table</ToggleButton>
                </ToggleButtonGroup>
            </Box>
        </Box>
        <Box sx={{ height: '100%', flex: 1, overflow: 'auto' }}>
            {error
                ? (
                        <Stack flexDirection='row' gap={2}>
                            <ReportProblemRoundedIcon color='error' />
                            <Typography>{errorMessage}</Typography>
                        </Stack>
                    )
                : data?.length === 0
                    ? (
                            <Typography>{noDataText}</Typography>
                        )
                    : (
                            data.map(renderContent)
                        )}
        </Box>
    </Stack>
)

export default PanelSection
